import React from 'react';
import '../less/index.less';
import ProductList from '../../../../../../../auxiliary-components/shared/ProductList';
import activeCredits from '../enums/active_credits.json';

export default function template() {
  const page = 'loans-corporate-clients-list';

  return (
    <div className="loans-corporate-clients-list">
      <ProductList
        title="LOANS_CORPORATE_CLIENTS_LIST_TITLE"
        items={activeCredits}
        page={page}
      />
    </div>
  );
}
